<div id="image-layer" :style="getStyle"></div>
